module.exports = __webpack_public_path__ + "img/1546396254.db94b7f8.jpg";